export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

export const getApprovalStatusText = (status: string): string => {
  switch (status) {
    case '': return '尚未處理...';
    case 'V': return '已初核,未審核...';
    case 'P': return '已審核,未複核...';
    case 'Y': return '已核准!';
    case 'N': return '不准 !!';
    default: return '尚未處理...';
  }
};

export const getApprovalFlagText = (flag: string): string => {
  if (flag && flag.trim()) return '須總經理核准';
  return '須一般核准';
};
